import { useQueryClient } from "@tanstack/react-query";

import { getGetMeQueryKey, useChangePassword, useGetMe, useUpdateUser } from "@/api";

export function useProfile() {
  const queryClient = useQueryClient();

  const { data, isLoading, isError } = useGetMe();
  const profile = data?.status === 200 ? data.data.data : undefined;

  const { mutate: updateUser, isPending: isUpdating } = useUpdateUser({
    mutation: {
      onSuccess: () => {
        void queryClient.invalidateQueries({ queryKey: getGetMeQueryKey() });
      },
    },
  });

  const { mutate: changePassword, isPending: isChangingPassword } = useChangePassword({
    mutation: {},
  });

  return {
    profile,
    isLoading,
    isError,
    isUpdating,
    isChangingPassword,
    updateUser,
    changePassword,
  };
}
